import { render } from "./Withholding_Vat.vue?vue&type=template&id=4382e155"
import script from "./Withholding_Vat.vue?vue&type=script&lang=js"
export * from "./Withholding_Vat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__